import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { teacherDetailPath } from "utils/teacherRoutes";

function TeacherProfileLink({ id, regNumber, children, fallback = null, ...linkProps }) {
  const to = teacherDetailPath(id, regNumber);
  if (!to) {
    return fallback ?? <>{children}</>;
  }
  return (
    <Link to={to} {...linkProps}>
      {children}
    </Link>
  );
}

TeacherProfileLink.propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  regNumber: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  children: PropTypes.node.isRequired,
  fallback: PropTypes.node,
};

export default TeacherProfileLink;
